<template>
    <div>
       <!--  <button-back/> -->
       
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torre_vh">
                <h1 class="caption__select">
                    <!-- <span>{{img.name}}</span>
                    <span>Seleccione un departamento, clic para ver detalles</span> -->
                </h1>
                <map-highlight :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url" />
                <div class="line_horizontal"></div> -->
                <div>
                    <image-location class="image__location-small" :typeImage="typeImage" :urlImg="urlImg"/>
                    <detail-location :totalMeters="true" :typeImage="typeImage"/>
                    <btn-detail style="margin-top:2rem" @clickBtn="openM()" />
               </div>
               <DetailModal :modalShow="modal" @modalHide="closeM">
                <template slot="title-detail">{{ modelDpt.name }}</template>
                 <template slot="content-detail">
                    <Detail />
                 </template>
               </DetailModal>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../core/rediseno/ButtonsPisos.vue";
/* import ButtonBack from "../../core/ButtonBack";
import Button from "../../core/Button.vue"; */
import ImageLocation from "../../core/rediseno/ImageIndividual";
import DetailLocation from "../../core/rediseno/DetailLocation";
import BtnDetail from "../../core/rediseno/BtnDetail.vue";
import DetailModal from "../../core/rediseno/modal/DetailModal";
import Detail from "../detailLocation/Main.vue"
export default {
    name: "Piso",
    components: {
        MapHighlight,
        /* Button,
        ButtonBack, */
        ImageLocation,
        DetailLocation,
        BtnDetail,
        DetailModal,
        Detail
    },
    data() {
        return {
            id: 50,
            levelId: this.$route.params.idPiso,
            type: "departamentos",
            desarrollo: "torrevistahermosapiso",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
            //image adition
            typeImage: "modeloDeptos",
            urlImg: 'torrevistahermosa/modelos',
            //
            pisos: {
                NIVEL01: {
                    name: 'NIVEL 01',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/plano_N-01_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '964',
                    transform: '',
                    viewBox: '0 0 938 964'
                },
                PB: {
                    name: 'PB',
                    url: '',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '964',
                    transform: '',
                    viewBox: '0 0 938 964'
                },
                NIVEL1: {
                    name: 'NIVEL 1',
                    url: '',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL2: {
                    name: 'NIVEL 2',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL3: {
                    name: 'NIVEL 3',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL4: {
                    name: 'NIVEL 4',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL5: {
                    name: 'NIVEL 5',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL6: {
                    name: 'NIVEL 6',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL7: {
                    name: 'NIVEL 7',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL8: {
                    name: 'NIVEL 8',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL9: {
                    name: 'NIVEL 9',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL10: {
                    name: 'NIVEL 10',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL11: {
                    name: 'NIVEL 11',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL12: {
                    name: 'NIVEL 12',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL13: {
                    name: 'NIVEL 13',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL14: {
                    name: 'NIVEL 14',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL15: {
                    name: 'NIVEL 15',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL16: {
                    name: 'NIVEL 16',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL17: {
                    name: 'NIVEL 17',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL18: {
                    name: 'NIVEL 18',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/2recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL19: {
                    name: 'NIVEL 19',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/3recamaras_sides.png',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
                NIVEL20: {
                    name: 'NIVEL 20',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/pisos/Piso1_PH_bordes.jpg',
                    width: '938',
                    id: 50,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '895',
                    transform: '',
                    viewBox: '0 0 938 895'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            //add
            modal:false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos",
            levelDept:"getStatusLevel",
            modelDpt:'getStatusA'
        }),
        development() {
            return { id: this.id, level: this.levelDept.id };
        },
        img() {
            const piso = this.$route.params.piso;
            const pisoSeleccionado = this.pisos[piso];
            return pisoSeleccionado;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        openM(){
            this.modal=true
        },
        closeM(){
            this.modal=false
        },
    },
    async created() {
        /* await this.getAvailableLocations(this.development);
        this.getFilterModelos(this.existFilter) */
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    mounted() {

    }
};
</script>
<style>
@media (min-width:1201px) {
    .maphighlight__box.torre_vh{
    width: 60%;   
    }
}
</style>
